export const USERS_COLUMNS = [
  {
    title: "Nombre",
  },
  {
    title: "Correo Electronico",
  },
  {
    title: "Telefono",
  },
  {
    title: "Contenedores",
  },
  {
    title: "Estado",
  },
  {
    title: "",
  },
];
